import { collaborationService } from 'Store/services/index';
import { observable, action, runInAction, computed } from 'mobx';
import { store } from './index';
import { compareDate } from '@/utils/date';
import  { message } from 'antd'
import { collaborationApi, docCollaborationApi } from 'Api/index';
import {  fileController } from "../components/viewer/Controllers/index";
import intl from 'react-intl-universal';
import cuid from 'cuid';
import { windowActionFn, isCNDomain, isJPDomain, getQueryVariable, deepCopy } from '@/utils/utils';
import { toJS } from 'mobx';

const fullScreenChange = async () => {
  const collToolbar = await pdfui.getComponentByName('collaboration-toolbar')

  if (!collToolbar) {
    return
  }
  if (document.fullscreenElement) {
    collToolbar.hide()
  } else {
    collToolbar.show()
  }
}

class CollaborationStore {
  @observable isOwnerDeleteCollaboratorAnnot = false
  @observable isCollaboratorAnnotBeDeletedByOwner = false
  @observable sharedFileInfo = {
    sharedDoc: '',
    annotsFDFArr: [],
    fileName: '',
  }
  @observable canComment = true
  @observable isCreatingShareReview = false
  @observable  isUploadedInitialAnnots = false
  @observable annotsCache = null
  @observable userInfo ={
    token:null,
    cUserID:null,
    userEmail:null,
  }
  @observable uuidForCollaboration = cuid();

  @observable annotTaskArr = []
  @observable annotAxiosTaskArr = []
  @observable annotListInitialTime = '0000-00-00 00:00:00:000'
  @observable annoInitialArr = []  // 初始加载时的annotList
  @observable annotList = []  // 所有的annotList
  @observable annotListFull = []  // 所有的annotList，只增不减，用于构造完整的annotTree

  @observable activeAnnot = null
  @observable ownerDeleteCollaboratorAnnotList = []
  @observable othersAnnotList = []
  @observable annotLastUpdateTime = '0000-00-00 00:00:00:000'
  // ShareDialogcreateShareFileLink
  @observable reviewSessionID = null;
  @observable isShowShareDialog = false; //是否躲藏
  @observable shareReviewData = {}
  @observable shareUserList = []
  @observable showDownLoadPanel = null
  @observable showDeadlineModel = false
  @observable deadlineSeconds = 0
  @observable deadlineSecondsTimer = null
  @observable deadlineTips = '';
  @observable isShow_deadlineTips = false;

  @observable shareReviewListParams={source:0};
  @observable viewModel = 'list';
  @observable isEmptyList = false;
  @observable isShowCollaborationSignIn = false;
  @observable isFromSharedList = false;

  @observable fwBeginShare = false; // 云编辑发起协同
  @observable docIsShare = false; // 云文档打开的文件是否是协同文件
  @observable thisCDocId = ""; // 文档的cdocId存储


  @action setFwBeginShare(val) {
    this.fwBeginShare = val // 本地发起协作后置为true，用于打开文件后进入协同状态，打开文件失败及进入协同后置为false。
  }
  @action setDocIsShare(val) {
    // 可以改为直接调用接口返回是否协同
    this.docIsShare = val // 云文档打开文件后通过接口查询当前文档是否协同，返回sharereviewId则置为true，用于打开文件后进入协同状态，打开文件失败及进入协同后置为false。
  }
  @action setThisCDocId(val) {
    this.thisCDocId = val 
  }

  @computed get isFromSharedLink() {
    const reviewSessionID = getQueryVariable('reviewSessionID')
    const fileLink = getQueryVariable('docUrl')
    const fileName = getQueryVariable('fileName')

    if (reviewSessionID && fileLink && fileName) {
      return true
    }

    return false
  }
  @action updateIsOwnerDeleteCollaboratorAnnot(value) {
    this.isOwnerDeleteCollaboratorAnnot = value
  }
  @action updateIsCollaboratorAnnotBeDeletedByOwner(value) {
    this.isCollaboratorAnnotBeDeletedByOwner = value
  }
  @action resetIsOwnerDeleteCollaboratorAnnot() {
    this.isOwnerDeleteCollaboratorAnnot = false
  }
  @action resetIsCollaboratorAnnotBeDeletedByOwner() {
    this.isCollaboratorAnnotBeDeletedByOwner = false
  }
  @action updateIsFromSharedList(value) {
    this.isFromSharedList = value
  }

  @action updateCanComment(val) {
    this.canComment = val
  }
  @action updateIsCreatingShareReview(val) {
    this.isCreatingShareReview = val
  }
  @action updateIsUploadedInitialAnnots(val) {
    this.isUploadedInitialAnnots = val
  }
  @action async restoreAnnotsForCache() {
    this.updateIsUploadedInitialAnnots(false)
    await fileController.importAnnotsFromFDF(this.annotsCache)
    await collaborationApi.removeCDocId()
    await fileController.clearAllUndoRedoStorage()
    
    if (!collaborationService.isDocModifiedBeforeShare || !store.appStore.docModified) {
      store.appStore.doUpdateDocModified(false)
      collaborationService.updateIsRestoreAnnotsForCache(true)
    }
  }
  @action async updateAnnotsCache() {
    this.annotsCache = await fileController.exportAnnotsToFDF()
  }
  @observable clean(){
    collaborationService.clean();
    this.userInfo = {};
  }
  @action updateSharedFileInfo({sharedDoc, annotsFDFArr, fileName}) {
    sharedDoc && Object.assign(this.sharedFileInfo, {sharedDoc})
    annotsFDFArr && Object.assign(this.sharedFileInfo, {annotsFDFArr})
    fileName && Object.assign(this.sharedFileInfo, {fileName})
  }
  @action spliceAnnotAxiosTaskArr(index) {
    this.annotAxiosTaskArr.splice(index, 1)
  }
  @action shiftAnnotTaskArr() {
    return this.annotTaskArr.shift()
  }
  @action pushAnnotTaskArr(task) {
    this.annotTaskArr.push(task)
  }
  @action clearAnnotTaskArr() {
    this.annotTaskArr = []
  }
  @action pushAnnotAxiosTaskArr(task) {
    this.annotAxiosTaskArr.push(task)
  }
  @action resetAnnotList() {
    this.annotList = []
    this.annotListFull = []
  }
  @action getRootAnnotNodeRecursiveAnnotNameArr(annotName) {
    let result = []
    const targetAnnotNode = this.getRootAnnotNode(annotName)[0]
    const recursiveAnnotNode = (annotNode) => {
      if (annotNode) {
        result.push(annotNode.annotName)

        if (annotNode.subAnnotArr && annotNode.subAnnotArr.length !== 0) {
          const { subAnnotArr } = annotNode

          subAnnotArr.forEach((annotNode) => {
            recursiveAnnotNode(annotNode)
          })
        }
      }
    }

    recursiveAnnotNode(targetAnnotNode)
    
    return result
  }
  @action getRootAnnotNode(annotName) {
    const annotListTree = this.getAnnotListTree()
    const targetAnnotNode = annotListTree.filter((annotNode) => {
      if (annotNode.annotName === annotName) {
        return true
      }
    })

    return targetAnnotNode
  }
  @action getAnnotListTree() {
    const annotList = toJS(this.annotListFull).slice()

    return this.getAnnotInitialTree(annotList)
  }
  @action getAnnotInitialTree(annotArr) {
    let rootAnnotArr = []
    let annotRemainArr = []
    let annotList = annotArr || this.annoInitialArr

    for (let i = annotList.length - 1; i >=0 ; i--) {
      const annot = annotList[i];

      if (!annot.annotInReplyTo) {
        rootAnnotArr.push(annot)
        annotList.splice(i, 1)
      }
    }

    subAnnotRecursive(rootAnnotArr, annotList)

    function subAnnotRecursive(parentAnnotArr, childAnnotArr) {
      let childAnnotLength = childAnnotArr.length

      if (!childAnnotLength) {
        return
      }

      for (let i = childAnnotArr.length - 1; i >=0 ; i--) {
        const childAnnot = childAnnotArr[i];

        parentAnnotArr.some((parentAnnot) => {
          if (childAnnot.annotInReplyTo && childAnnot.annotInReplyTo === parentAnnot.annotName) {
            if (parentAnnot.subAnnotArr) {
              parentAnnot.subAnnotArr.push(childAnnot)
            } else {
              parentAnnot.subAnnotArr = []
              parentAnnot.subAnnotArr.push(childAnnot)
            }

            childAnnotArr.splice(i, 1)

            return true
          }
        })
      }

      let parentAnnotArrForNext = []

      parentAnnotArr.forEach((annot) => {
        if (annot.subAnnotArr && annot.subAnnotArr.length) {
          parentAnnotArrForNext = [...parentAnnotArrForNext, ...annot.subAnnotArr]
        }
      })

      if (childAnnotLength === childAnnotArr.length) {
        annotRemainArr = childAnnotArr

        return
      }

      subAnnotRecursive(parentAnnotArrForNext, childAnnotArr)
    }

    // console.log('rootAnnotArr', [...rootAnnotArr, ...annotRemainArr]);

    if (annotList === this.annoInitialArr) {
      this.cleanAnnotInitialArr()
    }

    return [...rootAnnotArr, ...annotRemainArr]
  }
  @action cleanAnnotInitialArr() {
    this.annoInitialArr = []
  }
  @action updateAnnotInitialArr(annotArr) {
    this.annoInitialArr = [...this.annoInitialArr, ...annotArr]
    this.annotList = [...this.annotList, ...annotArr]
    this.annotListFull = [...this.annotListFull, ...annotArr]
  }
  @action addAnnotList(newAnnotArr){
    this.annotList = [...this.annotList, ...newAnnotArr]
    this.annotListFull = [...this.annotListFull, ...newAnnotArr]
  }
  @action deleteAnnotList(deleteAnnotArr){
    let list = this.annotList.slice();
    deleteAnnotArr.forEach(deleteAnnot=>{
      list.forEach((item,index)=>{
        if(item.annotName == deleteAnnot.annotName){
          list.splice(index,1)
        }
      })
    })
    this.annotList = list;
  }
  @action getUserInfoByAnnotName=(annotName)=>{
    let userName = null;
    let cUserID = null
    let avatar = null;
     this.annotList.slice().forEach(item=>{
      if(item.annotName == annotName ){
        // userEmail =  item.userEmail,
        cUserID = item.cUserID;
      }
    })

    if (!cUserID && store.userStore.userInfo && store.userStore.userInfo.cUserID) { //当前用户新增的annot可能没有及时添加到this.annotList中
      cUserID = store.userStore.userInfo.cUserID;
    }

    if(this.shareReviewData && this.shareReviewData.memberList && cUserID){
      this.shareReviewData.memberList.forEach(item=>{

        if(item.cUserID == cUserID ){
          try{
            userName = item.userName;
            avatar = item.avatar;
          }catch(err){}
        }
      })
      if(userName == null){
        // const {userInfo} = store.userStore;
        // userName = !!userInfo.fullname?userInfo.fullname:`${userInfo.firstname} ${userInfo.lastname}`;
        userName = store.userStore.userName;
      }
    }
    return { userID: cUserID, userName: userName, avatar: avatar };
  }
  @action isShareReviewOwner(cUserID) {
    let currentUserID
    let shareReviewOwnerUserID

    if (cUserID) {
      currentUserID = cUserID
    } else if (store.userStore.userInfo && store.userStore.userInfo.cUserID) {
      currentUserID = store.userStore.userInfo.cUserID
    }
    if (this.shareReviewData && this.shareReviewData.cUserID) {
      shareReviewOwnerUserID = this.shareReviewData.cUserID
    }
    if (currentUserID && shareReviewOwnerUserID && (currentUserID === shareReviewOwnerUserID)) {
      return true
    }

    return false
  }
  @action async unActiveAnnot() {
    if (!this.activeAnnot) {
      return;
    }

    const { page, name } = this.activeAnnot;
    const pageRender = pdfui.pdfViewer.getPDFPageRender(page)
    if( pageRender ){
      pageRender.annotsRender.unActiveAnnot(name);
    }
  }
  @action updateActiveAnnot(annotData) {
    this.activeAnnot = annotData
  }
  @action clearActiveAnnot() {
    this.activeAnnot = null
  }
  @action resetCollaborationData() {
    this.resetAnnotList()
    this.othersAnnotList = []
    this.annotLastUpdateTime = '0000-00-00 00:00:00:000'
    this.reviewSessionID = null
    this.shareReviewData = {}
    this.annotAxiosTaskArr = []
    this.canComment = true
    this.isFromSharedList = false
  }
  @action removeAnnotFromOthersAnnotList(annotName) {
    const index = this.othersAnnotList.indexOf(annotName)

    if (index > -1) {
      this.othersAnnotList.splice(index, 1)
    }
  }
  @action isAnnotOwner(annotName) {
    if (this.othersAnnotList.indexOf(annotName) > -1) {
      return false
    } else {
      return true
    }
  }
  // @action getAnnotOwnerCUserId(annotName) {
  //   let annot
  //   const index = this.othersAnnotList.indexOf(annotName)

  //   if (index > -1) {
  //     annot = this.othersAnnotList[index]

  //     return annot
  //   }
  // }
  @action isAnnotInOwnerDeleteCollaboratorAnnotList(annotName) {
    if (this.ownerDeleteCollaboratorAnnotList.indexOf(annotName) > -1) {
      return true
    } else {
      return false
    }
  }
  @action updateOwnerDeleteCollaboratorAnnotList(annotName) {
    this.ownerDeleteCollaboratorAnnotList.push(annotName)
  }
  @action updateOthersAnnotList(annotName) {
    this.othersAnnotList.push(annotName)
  }
  @action updateOthersAnnotList_all(){
    this.othersAnnotList = [];
    const { hasSignIn } = store.userStore;
    if(hasSignIn && store.userStore.userInfo && store.userStore.userInfo.cUserID){
      let list = this.annotList.slice();
      list.forEach((item)=>{
        if(item.cUserID != store.userStore.userInfo.cUserID){
          this.othersAnnotList.push(item.annotName)
        }
      })
    }

  }
  @action updateAnnotLastUpdateTime(dateTime) {
    if(compareDate(this.annotLastUpdateTime).isBefore(dateTime)) {
      this.annotLastUpdateTime = dateTime
    }
  }
  @action changeDeadlineModel(isShow) {
    this.showDeadlineModel = isShow
  }
  @action changeShareDialogState(isShow) {
    this.isShowShareDialog = isShow
    document.body.style.overflow = isShow ? 'hidden' : 'auto'
  }
  @action getReviewSessionID() {
    return this.reviewSessionID;
  }
  @action setReviewSessionID(value) {
    this.reviewSessionID = value
  }
  @action createShareFileLink(option={ prohibitComment }) {
    store.collaborationStore.resetCollaborationData()
    this.updateIsCreatingShareReview(true)

    return collaborationService.createShareFileLink(option)
  }
  @action createShareFileLinkForTeamsApp(option={ prohibitComment }) {
    this.updateIsCreatingShareReview(true)

    return collaborationService.createShareFileLinkForTeamsApp(option)
  }
  @action createShareFileLinkAndInviteJoin(option) {
    store.collaborationStore.resetCollaborationData()
    this.updateIsCreatingShareReview(true)

    return collaborationService.inviteJoinWithEmail(option)
  }
  @action getShareRelationship() {
    const result = collaborationService.getShareRelationship()
    return result;
  }
  @action getShareReviewList(option) {
    const result = collaborationService.getShareReviewList(option)
    return result;
  }
  @action getShareReviewInviteParticipant(reviewSessionID) {
    return collaborationService.getShareReviewInviteParticipant(reviewSessionID)
  }
  @action inviteJoin(option) {
    return collaborationService.inviteJoin(option)
  }
  @action async getMoreOperationData() {
    await collaborationService.getMoreOperationData()
  }
  @action async phantomGetShareReview() {
    await this.getMoreOperationData()
    return this.getShareReview({ reviewSessionID:this.reviewSessionID, getMore: 1 })
  }
  @action async postDownloadFileLink({url}) {
    await collaborationService.postDownloadFileLink({url})
  }
  @action async postWinSizeMsg({name, width, height}) {
    await collaborationService.postWinSizeMsg({name, width, height})
  }
  @action setShareUserList(list = []) {
    this.shareUserList = [...list];
  }
  @action getShareUserList() {
    let cUserID = ''
    let shareUserList = JSON.parse(JSON.stringify(Array.from(this.shareUserList) ))
    
    if (store.userStore.hasSignIn) {
      cUserID = store.userStore.userInfo && store.userStore.userInfo.cUserID
    }

    shareUserList.forEach( item => item.isCurrentUser = item.cUserID === cUserID)
    return shareUserList;
  }
  @action sendMentionMsg(options) {
    options.reviewSessionID = this.reviewSessionID;
    return collaborationService.sendMentionMsg(options)
  }
  @action formetShareData(data) {
    const {docName, createTime, deadline,fileLink, cUserID, memberList=[], reviewSessionID, shareState} = data
    const userId = collaborationService.cUserID || (store.userNewStore.userData && store.userNewStore.userData.userId)
    let guestTxt = intl.get("collaboration.sharedList.guest");
    const people = memberList.map(item => {
      let name = guestTxt;
      if (item.cUserID) name = item.userName || 'unknown';
      return {name, ...item}
    })
    return {
      reviewSessionID,
      fileDetails: {
        name: docName,
        sharedTime: createTime,
        deadline,
        ...data
      },
      people,
      cDocID: data.docId || data.cDocID ,
      fileLink,
      type: cUserID==userId ? 'yours' : 'others',
      shareState,
      userId,
      cUserID
    }
  }
  @action async getShareReview(option) {    
    const shareReviewRes = await collaborationService.getShareReview(option)

    if (shareReviewRes.ret === 0) {
      this.setShareReviewData(shareReviewRes.data[0])
    }
    return Promise.resolve(shareReviewRes)
  }
  @action getShareReviewOperandsLog(option) {
    return collaborationService.getShareReviewOperandsLog(option)
  }
  @action putShareReview(option) {
    return collaborationService.putShareReview(option)
  }
  @action putShareReviewBatch(option) {
    return collaborationService.putShareReviewBatch(option)
  }
  @action shareReviewParticipant(options) {
    return collaborationService.shareReviewParticipant(options)
  }
  @action putShareReviewInviteParticipantBatch(options) {
    return collaborationService.putShareReviewInviteParticipantBatch(options)
  }
  @action downloadFile(options, showSpin) {
    return collaborationService.downloadFile(options, showSpin)
  }
 @action async hideSomeFeature() {
    // const importComment = await pdfui.getComponentByName('commentlist-import-comment').catch((error) => {
    //   throw error
    // })
    // const exportComment = await pdfui.getComponentByName('commentlist-export-comment').catch((error) => {
    //   throw error
    // })
    const fileProperty = await pdfui.getComponentByName('fv--contextmenu-item-file-property').catch((error) => {
      throw error
    })
    const bookmark = await pdfui.getComponentByName('fv--contextmenu-item-bookmark').catch((error) => {
      throw error
    })
    const createLink = await pdfui.getComponentByName('fv--contextmenu-item-createLink').catch((error) => {
      throw error
    })
    const contextMenuForForm = await pdfui.getComponentByName('contextmenu-form-designer');

    contextMenuForForm && contextMenuForForm.on('shown', () => {
      contextMenuForForm.querySelectorAll('*').forEach((it) => it.lock());
    });

    // importComment && importComment.hide()
    // exportComment && exportComment.parent.hide()
    bookmark && bookmark.hide()
    createLink && createLink.hide()
    fileProperty && fileProperty.hide()
  }
  @action async showSomeFeature() {
    // const importComment = await pdfui.getComponentByName('commentlist-import-comment').catch((error) => {
    //   throw error
    // })
    // const exportComment = await pdfui.getComponentByName('commentlist-export-comment').catch((error) => {
    //   throw error
    // })
    const fileProperty = await pdfui.getComponentByName('fv--contextmenu-item-file-property').catch((error) => {
      throw error
    })
    const bookmark = await pdfui.getComponentByName('fv--contextmenu-item-bookmark').catch((error) => {
      throw error
    })
    const createLink = await pdfui.getComponentByName('fv--contextmenu-item-createLink').catch((error) => {
      throw error
    })
    const contextMenuForForm = await pdfui.getComponentByName('contextmenu-form-designer');

    contextMenuForForm&&contextMenuForForm.on('shown', () => {
      contextMenuForForm.querySelectorAll('*').forEach((it) => it.unlock());
    });

    // importComment && importComment.show()
    // exportComment && exportComment.parent.show()
    fileProperty && fileProperty.show()
    bookmark && bookmark.show()
    createLink && createLink.show()
  }
  @action addEventListenerForCollaborationMode() {
    window.addEventListener('fullscreenchange', fullScreenChange)
  }
  @action removeEventListenerForCollaborationMode() {
    window.removeEventListener('fullscreenchange', fullScreenChange)
  }
  @action getPDFDoc() {
    return new Promise((resolve) => {
      collaborationService.getCurrentDoc().then(result => {
        if(result.ret === 0) {
          resolve(result.data.name)
        }
      })
    })
  }
  @action openSharedFileForPhantom(option) {
    console.log("协作 openSharedFileForPhantom")
    collaborationService.openSharedFile(option, false)
  }
  @action openSharedFile(option, from) {
    console.log("协作 openSharedFile")
    store.appStore.doUpdateDocModified(false)
    return collaborationService.openSharedFile(option, true, from)
  }
  @action async setShareToolBar(type) {
    const toolbar = await pdfui.getComponentByName('collaboration-toolbar')
    const sd = await pdfui.getComponentByName('sidebar')
    // const {hasSignIn } =store.userStore;
    // TODO FOXIT 云编辑协同功能菜单唤起
    const { isLogin } =store.loginNewStore;
    if(type) {
      if(isLogin){
        toolbar&& toolbar[type]();
      }else{
        toolbar&& toolbar.hide();
      }
      sd[type]()
    }
  }
  // TODO FOXIT 發起協助
  @action async startComment() {
    console.log("协作 startComment")
    store.appStore.doUpdateDocModified(false)
    this.openSharedFile()
    let sidebar = await window.pdfui.getComponentByName('comment-list-sidebar-panel')
    sidebar.active()
  }
  @action closeWindow() {
    collaborationService.closeWindow()
  }
  @action  queryShareViewData({reviewSessionID, getMore, cDocID}) {
    return new Promise((resolve) => {
      this.getShareReview({reviewSessionID, getMore, cDocID}).then( async (res) => {
        // const cUserID = !store.userStore.userInfo?null:store.userStore.userInfo.cUserID;
        const cUserID = !store.userNewStore.userData?null:store.userNewStore.userData.userId;
        if(res.ret ===0) {
          this.shareReviewData = { ...res.data[0] }
          // let {userId, avatar, isDefaultAvatar} = store.userStore;
          // TODO FOXIT  设置头像， 云编辑怎么修改？？？容我想想
          let {userId, avatar, isDefaultAvatar} = store.userNewStore.userData;
          let hasAvatar = false;
          let prohibitComment = this.shareReviewData.prohibitComment;
          this.shareReviewData.memberList.map(item => {
            if(userId == item.cUserID) {
              store.userStore.updateUserName({showName: item.userName});
              pdfui.setUserName(item.userName);
              if(item.avatar) {
                hasAvatar = true;
                avatar = item.avatar;
                isDefaultAvatar = 0;
              }
            }
          })
          if(hasAvatar === true) {
            store.userStore.updateUserAvatar({avatar, isDefaultAvatar});
          }
          if(cUserID){
            this.shareReviewData.memberList.forEach(item=>{
              if(item.cUserID == cUserID){
                prohibitComment= item.prohibitComment;
              }
            })
          }
          let type = prohibitComment === 0 ||this.isShareReviewOwner(cUserID) ? 'show' : 'hide'
          this.setShareToolBar(type)
          if(this.shareReviewData.deadlineSeconds) this.setDeadline(this.shareReviewData.deadlineSeconds)
          resolve(res)
        } else {
          resolve(res)
        }
      })
    })
  }
  @action updateShareReviewParticipantList(res) {
    const { ret, data } = res;
    if (ret === 0) {
      let { userId, avatar, isDefaultAvatar } = store.userStore;
      let guestTxt = intl.get('collaboration.sharedList.guest');
      let shareReviewData = deepCopy(this.shareReviewData);
      let hasAvatar = false;
      let userName = '';
      shareReviewData.memberList = data.list;
      shareReviewData.people = data.list.map(item => {
        if (userId == item.cUserID) {
          store.userStore.updateUserName({ showName: item.userName });
          pdfui.setUserName(item.userName);
          if (item.avatar) {
            hasAvatar = true;
            avatar = item.avatar;
            isDefaultAvatar = 0;
          }
        }
        if (item.isOwner === 1) {
          userName = item.userName;
        }
        const name = item.isGuest === 1 ? guestTxt : (item.userName || 'unknown');
        return { name, ...item };
      });
      shareReviewData.userName = userName;
      this.setShareReviewData(shareReviewData);
      if (hasAvatar === true) {
        store.userStore.updateUserAvatar({ avatar, isDefaultAvatar });
      }
    }
  }
  @action setShareReviewData(data) {
    this.shareReviewData = data;
  }
  @action getCurrentViewMode() {
    const canViewMode = 'can view'
    const canCommentMode = 'can comment'
    const { userInfo } = store.userStore

    // 协作创建者返回编辑模式
    if (userInfo && this.isShareReviewOwner(userInfo.cUserID)) {
      return canCommentMode
    }

    if (!this.shareReviewData || Object.keys(this.shareReviewData).length === 0) {
      return canViewMode
    }

    const { prohibitComment, memberList } = this.shareReviewData

    if (prohibitComment === 1) {
      return canViewMode
    }

    const currentUser = memberList.filter((item) => {
      if (userInfo && (item.cUserID === userInfo.cUserID)) {
        return true
      }
    })

    // 协作链接加入的用户memberList中没有记录
    // 从协作链接加入的用户且文档权限为非禁止评论的返回编辑模式
    if (currentUser.length === 0 && prohibitComment === 0) {
      return canCommentMode
    }

    // 从协作链接加入的用户且文档权限为禁止评论的返回阅览模式
    if (currentUser.length === 0 && prohibitComment === 1) {
      return canViewMode
    }

    if (currentUser.length !== 0 && currentUser[0].prohibitComment === 0) {
      return canCommentMode
    } 
    if (currentUser.length !== 0 && currentUser[0].prohibitComment === 1) {
      return canViewMode
    }
  }
  @action async confirmInvitation(reviewSessionID=null) {
    // TODO FOXIT 修改信息为云编辑用户信息
    // const cUserID = !store.userStore.userInfo?null:store.userStore.userInfo.cUserID;
    const cUserID = !store.userNewStore.userData?null:store.userNewStore.userData.userId;
    if(!reviewSessionID) {
      reviewSessionID = this.shareReviewData.reviewSessionID;
    }
    return collaborationService.confirmInvitation({ reviewSessionID, cUserID })
  }
  @action setShowDownLoadPanel(method) {
    this.showDownLoadPanel = method
  }
  @action openCPDFTocllaborationMode() {
    const { shareReviewData } = store.collaborationStore

    // 已经停止分享的文档在服务器上还是CPDF文档，所以若是已经停止分享的文档需要切换到Common模式
    if (shareReviewData && shareReviewData.shareState === 1) {
      store.appStore.setCommonMode()

      return
    }
    if (shareReviewData && shareReviewData.shareState === 0) {
      store.appStore.setCollaborationMode();
    }

    return collaborationService.openCPDFTocllaborationMode().then(async (result) => {
      const { status, reviewSessionID} = result
      const { isFromSharedList } = store.collaborationStore

      if(status) {
        if(store.userStore.hasSignIn && !this.isFromSharedLink && !isFromSharedList){
          let res = await store.collaborationStore.confirmInvitation(reviewSessionID);
          if(res.ret === 110015) {
            message.error(intl.get("collaboration.Error.limitOnJoin"));
            return '';
          }
        }
        this.setReviewSessionID(reviewSessionID)
        !store.appStore.isCollaborationMode() && store.appStore.setCollaborationMode();
        store.appStore.updateShowHomeStart(false)
        // TODO FOXIT 这里需要多一层的判断，是否有权限，无权限的要禁用按钮
        if(store.shareCollaborationStore.shareInfo) {
          let shareInfo = store.shareCollaborationStore.shareInfo
          if(shareInfo.aclScope == "1") {
            let shareUserList = store.shareCollaborationStore.shareUserList
            let idList = shareUserList.map(item => {return item.userId})
            if(idList.includes(store.userNewStore.userData.userId.toString())) {
              // 可注释
              this.shareCollaborationCanAnnot(true)
              // 优先判断当前用户的权限
              let shareUserList = store.shareCollaborationStore.shareUserList
              shareUserList.forEach(item => {
                if(item.userId == store.userNewStore.userData.userId.toString()) { // 获取当前用户的权限
                  if(item.acl == "0") { // 可查看
                    console.log("可查看")
                    this.shareCollaborationCanAnnot(false)
                  } else if (item.acl == "1") { // 可注释
                    console.log("可注释2")
                    this.shareCollaborationCanAnnot(true)
                  }
                }
              })
            }
          } else if (shareInfo.aclScope == "0") {
            if(shareInfo.acl === "0") { // 可查看
              console.log("可查看")
              this.shareCollaborationCanAnnot(false)
            } else if (shareInfo.acl == "1") { // 可注释
              console.log("可注释2")
              this.shareCollaborationCanAnnot(true)
            }
            // 优先判断当前用户的权限
            let shareUserList = store.shareCollaborationStore.shareUserList
            shareUserList.forEach(item => {
              if(item.userId == store.userNewStore.userData.userId.toString()) { // 获取当前用户的权限
                if(item.acl == "0") { // 可查看
                  console.log("可查看")
                  this.shareCollaborationCanAnnot(false)
                } else if (item.acl == "1") { // 可注释
                  console.log("可注释2")
                  this.shareCollaborationCanAnnot(true)
                }
              }
            })
          }
        }
        store.appStore.showLoadingWithMsg({show:true,msg:'Initialize'})
        console.log("collaborationService.getAnnotListAll 1")
        await collaborationService.getAnnotListAll({ reviewSessionID: reviewSessionID, lastTime: '0000-00-00 00:00:00:000', pageObjNum: '-1', isInitial: true}).catch(() => {
          store.appStore.showLoading(false)
        })
        collaborationService.renderAnnotInitialTree()
      } else {
        store.appStore.setCommonMode()
      }
      store.collaborationStore.updateIsFromSharedList(false)
      return true;
    })
  }
  @action async shareCollaborationCanAnnot(canAnnot) {
    if (store.shareCollaborationStore.shareUserType === "createShareUser") {
      return
    }
    let collaborationToolbar = await window.pdfui.getComponentByName('fv--collaboration-toolbar-paddle')
    let btnList = ['create-highlight', 'create-strikeout', 'create-squiggly', 'create-underline', 'create-replace', 'create-caret', 'create-text', 'freetext-typewriter', 'freetext-textbox', 'freetext-callout', 'comment-tab-group-drawing', 'pencil-tool', 'eraser-tool', 'create-area-highlight', 'create-measurement-button-list', 'comment-tab-group-stamp', 'commentlistEx']
    let pageBtn = ['fv--underline-contextmenu']
    btnList.map(async (item) => {
      let component = await collaborationToolbar.getComponentByName(item)
      if(canAnnot) {
        component && component.enable()
      } else {
        component && component.disable()
      }
    })
    return pdfui.getRootComponent().then(root => {
      pageBtn.forEach(item=>{
        const component = root.getComponentByName(item);
        if(component) {
          component.lock();
          component.disable();
        }
      });
    })
  }
  @action renderAnnotInitialTree(){
    collaborationService.renderAnnotInitialTree()
  }
  @action setIsShow_deadlineTips(value){
    this.isShow_deadlineTips = value
  }

  @action alertNotification(txt){
    this.deadlineTips = txt;
    this.setIsShow_deadlineTips(true)
    setTimeout(()=>{
     this.closeNotification();
    },10000)
  }
  @action closeNotification(){
    this.isShow_deadlineTips= false;
    setTimeout(()=>{
      this.deadlineTips = null;
    },200)
  }
  @action setDeadline(countDown) {
    this.deadlineSeconds = countDown;

    this.clearTimer();
    const fileName = this.shareReviewData.docName;
    this.deadlineSecondsTimer = setInterval(() => {
      this.deadlineSeconds--;
      if(this.deadlineSeconds === 21600){
        this.alertNotification(intl.getHTML('collaboration.alertNotification.last_6h', {FileName: fileName}))
      }
      if(this.deadlineSeconds === 300){
        this.alertNotification(intl.getHTML('collaboration.alertNotification.last_5m', {FileName: fileName}))
      }
      if(this.deadlineSeconds === 0) {
        this.clearTimer()
        // this.changeDeadlineModel(true)
        store.appStore.onShowWarningMessage(() => {
          this.exitCollaboration(store.collaborationStore.isShareReviewOwner()? false: true)
        }, {message:"collaboration.Dlg.reachDeadline", title:"PhantomPDF.Online.TitleWithOnline"}, true)
      }
    }, 1000)
  }
  @action clearTimer() {
    clearInterval(this.deadlineSecondsTimer)
  }
  @action exitCollaboration(closePage) {
    if(closePage) {
      store.historyStore.goToHomePage()
      store.appStore.backToHomeStart()
      window.pdfui.pdfViewer.close()
    } else {
      const vTest = getQueryVariable("test");

      if (vTest === 'performance') {
        window.history.pushState({},'','/?test=performance')
      } else {
        window.history.pushState({},'','/')
      }

      store.appStore.setCommonMode()
    }
    this.clearTimer();
  }

  @action exitCollaborationForTeamsApp(closePage) {
    if(closePage) {
      // location.reload();
      store.appStore.backToHomeStart()
      window.pdfui.pdfViewer.close()
    } else {
      window.history.pushState({},'','/')
      store.appStore.setCommonMode()
    }
    this.clearTimer();
    store.accountStore.clean();
    store.userStore.clean();
  }

  _notificationPollingConfig = {
    minimumPollingTime: 15, // 最小轮询间隔时间
    maxPollingNotResultCount: 250, // 最大无结果的轮询次数
  }
  async _getNotificationPollingConfig() {
    const config = this._notificationPollingConfig
    if (config.minimumPollingTime <= 0 || config.maxPollingNotResultCount <= 0) {
      const { minimumPollingTime, maxPollingNotResultCount } = await collaborationService.getNotificationPollingConfig()
      config.minimumPollingTime = minimumPollingTime
      config.maxPollingNotResultCount = maxPollingNotResultCount
    }

    return config
  }
  get minimumPollingTime() {
    return (async () => (await this._getNotificationPollingConfig()).minimumPollingTime)()
  }
  _notificationPollingPool = {
    timeoutIDs: [], // 轮训句柄数组
    stopped: true, // 轮训是否停止
  }
  @observable notificationStatistic = {
    nextPollingTime: 0, // 服务器建议下次轮询间隔时间
    untreatedNotify: 0, // 是否存在消息
  }
  @action async startNotificationPolling() {
    if (!store.userStore.hasSignIn) return

    const pool = this._notificationPollingPool

    if (!pool.stopped) return

    pool.stopped = false
    await this._notificationPolling()
  }
  async _notificationPolling() {
    if (!store.userStore.hasSignIn) return

    const pool = this._notificationPollingPool

    if (pool.stopped) return

    const statistic = this.notificationStatistic
    const { nextPollingTime, untreatedNotify } = await collaborationService.getNotificationStatistic()
    statistic.nextPollingTime = nextPollingTime || this.minimumPollingTime
    statistic.untreatedNotify = untreatedNotify

    const { timeoutIDs } = pool

    const timeID = setTimeout(() => {
      clearTimeout(timeID)
      runInAction(() => this._notificationPolling())
      timeoutIDs.splice(timeoutIDs.indexOf(timeID), 1)
    }, statistic.nextPollingTime * 1000)
    timeoutIDs.push(timeID)
  }
  setUntreatedNotify(value) {
    const statistic = this.notificationStatistic
    statistic.untreatedNotify = value
  }
  stopNotificationPolling() {
    // if (store.userStore.hasSignIn) return

    const pool = this._notificationPollingPool

    if (pool.stopped) return

    pool.stopped = true
  }
  get notificationIFrameSrc() {
    let url = null
    try {
      url = new URL(collaborationService.getNotificationIFrameSrc({
        al: store.appStore.lng.full,
      }))
      return {
        href: url.href,
        origin: url.origin,
      }
    } catch {
      return {}
    }
  }
  @action handleErrorMsg(errMsg){
    let errorInfo;
    switch(errMsg.ret){
      case '100000':
        errorInfo = 'FAIL';
        break;
        case '110001':
        errorInfo = 'PARAMETER_IS_NOT_VALID';
        break;
        case '110002':
        errorInfo = 'DOCUMENT_IS_NOT_EXIST';
        break;
        case '110007':
        errorInfo = 'REVIEWSESSIONID_IS_NOT_EXIST';
        break;
        default :
        errorInfo = 'FAIL';
        break;
    }
    this.postErrorMsg({type:'error',errorInfo});
  }
  @action postErrorMsg({type,errorInfo}){
    docCollaborationApi.postErrorMsg({type,errorInfo})
  }
  @action messageError({type,errorInfo}){
    if(type == 'warning'){
      message.warning(errorInfo)
    }else{
      message.error(errorInfo)
    }
  }
  @action setUserInfo({token,cUserID,userEmail}){
    this.userInfo = {
      token,
      cUserID,
      userEmail
    }
  }
  @action setShareListParams(obj){
    this.shareReviewListParams = obj
  }
  @action changeTab(value){
    this.shareReviewListParams.source = value
  }
  @action changeView(view){
    this.viewModel = view;
  }
  @action updateEmptyList (value){
    this.isEmptyList= value
  }
  @action updateIsShowCollaborationSignIn(value){
    this.isShowCollaborationSignIn = value
  }
  @action onGoForDownload = () => {
    let targetUrl = 'https://www.foxit.com/downloads'
    const urlCN = 'https://www.foxitsoftware.cn/downloads'
    const urlJP = 'https://www.foxit.co.jp'

    if (isCNDomain()) {
      targetUrl = urlCN
    }
    if (isJPDomain()) {
      targetUrl = urlJP
    }

    windowActionFn(window, 'open', [targetUrl, '_blank']);
  }
  @action async removeCDocId() {
    await collaborationApi.removeCDocId().catch((error) => {
      throw error
    })
  }
}

export default CollaborationStore
